import cn from 'classnames';
import styles from './Article.module.scss';
import toast from 'react-hot-toast';

type ArticleProps = {
  className?: string;
  article: string;
  productId: number;
};

export function Article({ className, article, productId }: ArticleProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  const handleCopy = () => {
    navigator.clipboard.writeText(article);
    toast.success('Артикул скопирован');
  };

  const handleProductIdCopy = () => {
    navigator.clipboard.writeText(String(productId));
    toast.success('ID товара скопирован');
  };

  return (
    <div className={styles.metadata}>
      <div className={wrapperClassName}>
        <div className={styles.article}>Артикул: </div>
        <div className={styles.value}>{article}</div>
        <img
          src="/svg/copy.svg"
          alt="Копировать артикул"
          className={styles.copy}
          onClick={handleCopy}
        />
      </div>
      <div className={wrapperClassName}>
        <div className={styles.article}>ID товара: </div>
        <div className={styles.value}>{productId}</div>
        <img
          src="/svg/copy.svg"
          alt="Копировать ID товара"
          className={styles.copy}
          onClick={handleProductIdCopy}
        />
      </div>
    </div>
  );
}
